import type { MindboxSearchCustomFields, MindboxSearchPayloadParams } from './types';
import {
  mapArrayToLabels,
  mapDurationInterval,
  mapExcursionFormatTypes,
  mapMovementTypes,
  mapRubrics,
  mapSorting,
  mapStartTime,
  mindboxExcursionNumberOfPeople,
  toMindboxDate,
  toNumber,
} from './helpers';

/**
 * Собирает customerAction.customFields для операции Mindbox SearchExcursionsListing (экскурсии).
 */
export const buildMindboxSearchPayload = (params: MindboxSearchPayloadParams): MindboxSearchCustomFields => {
  const {
    productType,
    searchState,
    cityName,
    countryName,
    movementTypeLabels,
    formatLabels,
    durationLabels,
    startTimeLabels,
    sortingLabels,
    comfortLabels,
    accommodationLabels,
    activityLevelLabels,
  } = params;
  const [priceMin, priceMax] = searchState.price;

  return {
    searchType: productType,
    searchCityName: cityName ?? '',
    searchCountryName: countryName ?? '',
    searchDateFrom: toMindboxDate(searchState.date.from),
    searchDateTo: toMindboxDate(searchState.date.to),
    searchPriceMin: toNumber(priceMin),
    searchPriceMax: toNumber(priceMax),
    searchWithKids: searchState.childrenAllowed === true,
    searchNumberOfPeople: mindboxExcursionNumberOfPeople(searchState),
    searchMovementType: mapMovementTypes(searchState.movementTypes, movementTypeLabels),
    searchDuration: mapDurationInterval(searchState.durationInterval, durationLabels),
    searchFormat: mapExcursionFormatTypes(searchState, formatLabels),
    searchRubrics: mapRubrics(searchState.tag__slugs),
    searchStartTime: mapStartTime(searchState.startTimeInterval, startTimeLabels),
    searchSortBy: mapSorting(searchState.sorting, sortingLabels),
    searchComfort: mapArrayToLabels([], comfortLabels),
    searchAccommodationType: mapArrayToLabels([], accommodationLabels),
    searchActivityLevel: mapArrayToLabels([], activityLevelLabels),
  };
};
